import { axios } from "@Root/API";

export const putStudiesStudyProgramme = data => {
  return axios.put("students/course-session/update", data);
};
